import { render, staticRenderFns } from "./rezervasyonList.vue?vue&type=template&id=7f1d791d&scoped=true&"
import script from "./rezervasyonList.vue?vue&type=script&lang=js&"
export * from "./rezervasyonList.vue?vue&type=script&lang=js&"
import style0 from "./rezervasyonList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rezervasyonList.vue?vue&type=style&index=1&id=7f1d791d&lang=scss&scoped=true&"
import style2 from "./rezervasyonList.vue?vue&type=style&index=2&id=7f1d791d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d791d",
  null
  
)

export default component.exports